/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_TitleInputs */

const id_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang`)
};

const ms_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perihal`)
};

const da_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const de_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über`)
};

const en_us2_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const es_es2_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const es_mx2_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fil_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol Sa`)
};

const fr_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const it_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const hu_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Névjegy`)
};

const nl_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over`)
};

const no_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const pl_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nas`)
};

const pt_br2_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const pt_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const ro_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despre`)
};

const fi_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa`)
};

const sv_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const vi_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới thiệu`)
};

const tr_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında`)
};

const cs_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nás`)
};

const bg_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Относно`)
};

const ru_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О проекте`)
};

const uk_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про нас`)
};

const ar_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حول`)
};

const hi_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे बारे में`)
};

const th_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ`)
};

const ja_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_cn2_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const zh_hant1_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於`)
};

const ko_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소개`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Privacy_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_title = /** @type {((inputs?: Privacy_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_title(inputs)
	if (locale === "ms") return ms_privacy_title(inputs)
	if (locale === "da") return da_privacy_title(inputs)
	if (locale === "de") return de_privacy_title(inputs)
	if (locale === "en-US") return en_us2_privacy_title(inputs)
	if (locale === "es-ES") return es_es2_privacy_title(inputs)
	if (locale === "es-MX") return es_mx2_privacy_title(inputs)
	if (locale === "fil") return fil_privacy_title(inputs)
	if (locale === "fr") return fr_privacy_title(inputs)
	if (locale === "it") return it_privacy_title(inputs)
	if (locale === "hu") return hu_privacy_title(inputs)
	if (locale === "nl") return nl_privacy_title(inputs)
	if (locale === "no") return no_privacy_title(inputs)
	if (locale === "pl") return pl_privacy_title(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_title(inputs)
	if (locale === "pt") return pt_privacy_title(inputs)
	if (locale === "ro") return ro_privacy_title(inputs)
	if (locale === "fi") return fi_privacy_title(inputs)
	if (locale === "sv") return sv_privacy_title(inputs)
	if (locale === "vi") return vi_privacy_title(inputs)
	if (locale === "tr") return tr_privacy_title(inputs)
	if (locale === "cs") return cs_privacy_title(inputs)
	if (locale === "bg") return bg_privacy_title(inputs)
	if (locale === "ru") return ru_privacy_title(inputs)
	if (locale === "uk") return uk_privacy_title(inputs)
	if (locale === "ar") return ar_privacy_title(inputs)
	if (locale === "hi") return hi_privacy_title(inputs)
	if (locale === "th") return th_privacy_title(inputs)
	if (locale === "ja") return ja_privacy_title(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_title(inputs)
	return ko_privacy_title(inputs)
});
export { privacy_title as "privacy.title" }